import { useSelector } from 'react-redux';

/**
 * Хук для получения статуса авторизации
 * Предоставляет информацию о готовности аутентификации для последовательной загрузки
 */
export const useAuthStatus = () => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const authInProgress = useSelector(state => state.auth.authInProgress);
    const user = useSelector(state => state.auth.user);
    
    return {
        isAuthenticated,
        authInProgress,
        isReady: isAuthenticated && !authInProgress && !!user,
        user
    };
};

/**
 * Хук для проверки готовности аутентификации (упрощенная версия)
 * Используется в компонентах, которым нужно ждать завершения авторизации
 */
export const useAuthReady = () => {
    const { isReady } = useAuthStatus();
    return isReady;
};
